(function () {
  function initUpsell() {
    const el = document.querySelector('#CartDrawer #SfCartUpsell');
    if (!el) return;

    // IMPORTANT: ne bloque pas toute réinit, on veut pouvoir rebind les arrows aussi
    const wrap = el.closest('.sf-upsell-wrap') || document.querySelector('#CartDrawer #SfUpsellWrap');
    const prevBtn = wrap ? wrap.querySelector('.sf-upsell-arrow--prev') : null;
    const nextBtn = wrap ? wrap.querySelector('.sf-upsell-arrow--next') : null;

    // === Helper: scroll by one "card" ===
    const getStep = () => {
      const slide = el.querySelector('.sf-upsell__slide');
      if (!slide) return 220;
      const styles = window.getComputedStyle(el);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return slide.getBoundingClientRect().width + gap;
    };

    const scrollToDir = (dir) => {
      const step = getStep();
      el.scrollBy({ left: dir * step, behavior: 'smooth' });
    };

    // === Bind arrows (desktop only via CSS, but JS can stay) ===
    // Prevent double-binding
    if (prevBtn && prevBtn.dataset.sfBound !== '1') {
      prevBtn.dataset.sfBound = '1';
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        scrollToDir(-1);
      });
    }

    if (nextBtn && nextBtn.dataset.sfBound !== '1') {
      nextBtn.dataset.sfBound = '1';
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        scrollToDir(1);
      });
    }

    // === Add-to-cart (AJAX) + refresh drawer ===
    if (el.dataset.sfInit !== '1') {
      el.dataset.sfInit = '1';

      el.addEventListener('click', async (e) => {
        const btn = e.target.closest('.sf-upsell__cta');
        if (!btn) return;

        const form = btn.closest('form.sf-upsell__form');
        if (!form) return;

        e.preventDefault();
        if (btn.disabled) return;
        btn.disabled = true;

        try {
          const body = new URLSearchParams(new FormData(form)).toString();

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
              Accept: 'application/json',
            },
            body,
          });

          if (!res.ok) throw new Error('Add to cart failed');
          const added = await res.json();

          // Notify Dawn cart system (cart.js listens to PUB_SUB_EVENTS.cartUpdate)
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
            publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'sf-upsell',
              variantId: added?.variant_id,
            });
          } else {
            // fallback: reload key nodes from cart-drawer section
            fetch(`${window.routes.cart_url}?section_id=cart-drawer`)
              .then((r) => r.text())
              .then((htmlText) => {
                const html = new DOMParser().parseFromString(htmlText, 'text/html');
                const selectors = ['#SfShipbarMount', 'cart-drawer-items', '.cart-drawer__footer'];
                selectors.forEach((sel) => {
                  const target = document.querySelector(sel);
                  const source = html.querySelector(sel);
                  if (target && source) target.replaceWith(source);
                });
              });
          }
        } catch (err) {
          console.warn('[sf-upsell] add to cart error', err);
        } finally {
          btn.disabled = false;
        }
      });

      // Drag to scroll (desktop)
      let isDown = false;
      let startX = 0;
      let scrollLeft = 0;

      el.addEventListener('mousedown', (e) => {
        isDown = true;
        el.classList.add('sf-upsell--dragging');
        startX = e.pageX - el.offsetLeft;
        scrollLeft = el.scrollLeft;
      });

      el.addEventListener('mouseleave', () => {
        isDown = false;
        el.classList.remove('sf-upsell--dragging');
      });

      el.addEventListener('mouseup', () => {
        isDown = false;
        el.classList.remove('sf-upsell--dragging');
      });

      el.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - el.offsetLeft;
        const walk = (x - startX) * 1.2;
        el.scrollLeft = scrollLeft - walk;
      });
    }
  }

  document.addEventListener('DOMContentLoaded', initUpsell);

  // Re-init when cart drawer DOM is replaced
  const drawer = document.getElementById('CartDrawer');
  if (drawer) {
    const obs = new MutationObserver(() => {
      // rebind arrows + keep add-to-cart bound once
      initUpsell();
    });
    obs.observe(drawer, { childList: true, subtree: true });
  }
})();
